import React from 'react';
import { Flex } from '@chakra-ui/react';
import { localise } from '../../../../services/lang/lang';
import ScrollablePanel from './ScrollablePanel';
const RemoteSubmissionElementsPanel = ({ remoteSubmission }) => {
    const elementString = remoteSubmission.elements
        .map((element) => element.name)
        .join(', ');
    return (React.createElement(Flex, { "data-testid": "elements_panel" },
        React.createElement(ScrollablePanel, { title: localise('ELEMENTS'), condition: !!remoteSubmission.elements?.length, fallbackText: localise('NONE_ADDED'), "data-testid": "remote_submission_panel__elements" }, elementString)));
};
export default RemoteSubmissionElementsPanel;
